import { RADAR_NAV_TITLE } from './reportingProductLabels';

export const TRIAL_CLUSTER_LIMIT = 5;

export const EXPIRED_TRIAL_READONLY_TOOLTIP =
  'This feature is unavailable because the 30-day trial has expired. Contact sales to regain access.';

export const FREE_INCLUDED = [
  `${RADAR_NAV_TITLE} feature`,
  `Up to ${TRIAL_CLUSTER_LIMIT} connected clusters`,
  '30-day data retention',
];

export const FREE_EXCLUDED = [
  'Automated cluster optimization',
  'Automated workload autoscaler',
  'Unlimited clusters',
];

export const TRIAL_INCLUDED = [
  'Automated cluster optimization',
  'Automated workload autoscaler',
  'Connect unlimited clusters',
  'No credit card required',
];
